import { useState, useEffect } from "react";

const C = {
  pink: "#F7A1C4", mint: "#9ED9C3", yellow: "#FFD966",
  blue: "#9CCBFF", lilac: "#D7B7F6", ink: "#1F1F1F", cream: "#FFF8F1",
  pinkSoft: "#FDE8F0", mintSoft: "#E6F5EE", yellowSoft: "#FFF7DC",
  blueSoft: "#E4F0FF", lilacSoft: "#F0E5FC",
};
const heading = "'Baloo 2', cursive, sans-serif";
const body = "'Nunito', sans-serif";
const navMap = { "Home": "home", "Meet The Bunch": "meet", "Classes": "classes", "Gallery": "gallery", "Reviews": "reviews", "Parties": "parties", "Merch": "merch", "Schools": "schools", "Contact": "contact" };


const IMG = {
  dottie: "/images/characters/dottie.webp",
  logo: "/images/logo.webp",
};

const terms = [
  {
    name: "Term 1", dates: [
      { date: "Thu 19 Mar", label: null },
      { date: "Thu 26 Mar", label: null },
      { date: "Thu 2 Apr", label: "Easter Spectacular" },
    ],
  },
  {
    name: "Easter Holiday Special", special: true, dates: [
      { date: "Fri 10 Apr", label: "Extended Dance Party", special: true },
    ],
  },
  {
    name: "Easter Holiday Special (PM)", special: true, dates: [
      { date: "Fri 10 Apr PM", label: "Extended Dance Party", special: true },
    ],
  },
  {
    name: "Term 2", dates: [
      { date: "Thu 23 Apr", label: null },
      { date: "Thu 30 Apr", label: null },
      { date: "Thu 7 May", label: null },
      { date: "Thu 14 May", label: null },
      { date: "Thu 21 May", label: null },
    ],
  },
  {
    name: "May Half Term Special", special: true, dates: [
      { date: "Fri 29 May", label: "Holiday Dance Party", special: true, displayLabel: "Early session", time: "9:00 – 10:00" },
      { date: "Fri 29 May PM", label: "Holiday Dance Party", special: true, displayLabel: "Later session", time: "10:30 – 11:30" },
    ],
  },
  {
    name: "Term 3", dates: [
      { date: "Thu 4 Jun", label: null },
      { date: "Thu 11 Jun", label: null },
      { date: "Thu 18 Jun", label: null },
      { date: "Thu 25 Jun", label: null },
      { date: "Thu 2 Jul", label: null },
      { date: "Thu 16 Jul", label: null },
    ],
  },
  {
    name: "Summer Party", special: true, dates: [
      { date: "Mon 10 Aug", label: "Summer Party!", special: true, displayLabel: "Mon 10 Aug", time: "10:30 – 11:30" },
    ],
  },
  {
    name: "Autumn Term", dates: [
      { date: "Thu 10 Sep", label: null },
      { date: "Thu 17 Sep", label: null },
      { date: "Thu 24 Sep", label: null },
      { date: "Thu 1 Oct", label: null },
      { date: "Thu 8 Oct", label: null },
      { date: "Thu 15 Oct", label: null },
      { date: "Thu 22 Oct", label: null },
    ],
  },
  {
    name: "Winter Term", dates: [
      { date: "Thu 5 Nov", label: null },
      { date: "Thu 12 Nov", label: null },
      { date: "Thu 19 Nov", label: null },
      { date: "Thu 26 Nov", label: null },
      { date: "Thu 3 Dec", label: null },
      { date: "Thu 10 Dec", label: null },
      { date: "Thu 17 Dec", label: "Christmas Special" },
    ],
  },
];

const PRICE_SINGLE = 7;
const DISCOUNT = 0.1;
const MAX_CAPACITY = 15;
const SESSION_CAPACITY = {
  "Fri 29 May": 17,
  "Fri 29 May PM": 17,
};
// All sessions up to and including Christmas are closed — new term dates coming soon
const FORCED_FULL = {
  // Term 1
  "Thu 19 Mar": true, "Thu 26 Mar": true, "Thu 2 Apr": true,
  // Easter Holiday Special
  "Fri 10 Apr": true, "Fri 10 Apr PM": true,
  // Term 2
  "Thu 23 Apr": true, "Thu 30 Apr": true, "Thu 7 May": true, "Thu 14 May": true, "Thu 21 May": true,
  // May Half Term Special
  "Fri 29 May": true, "Fri 29 May PM": true,
  // Term 3
  "Thu 4 Jun": true, "Thu 11 Jun": true, "Thu 18 Jun": true, "Thu 25 Jun": true, "Thu 2 Jul": true, "Thu 16 Jul": true,
  // Summer Party
  "Mon 10 Aug": true,
  // Halloween Spooktacular
  "Thu 29 Oct": true,
  // Autumn Term
  "Thu 10 Sep": true, "Thu 17 Sep": true, "Thu 24 Sep": true, "Thu 1 Oct": true, "Thu 8 Oct": true, "Thu 15 Oct": true, "Thu 22 Oct": true,
  // Winter Term (up to and including Christmas)
  "Thu 5 Nov": true, "Thu 12 Nov": true, "Thu 19 Nov": true, "Thu 26 Nov": true,
  "Thu 3 Dec": true, "Thu 10 Dec": true, "Thu 17 Dec": true,
};

const specialPulseStyle = {
  animation: "specialPulse 2s ease-in-out infinite",
  boxShadow: "0 0 20px rgba(247, 161, 196, 0.4)",
};

const isDatePast = (dateStr) => {
  const months = { Jan:0, Feb:1, Mar:2, Apr:3, May:4, Jun:5, Jul:6, Aug:7, Sep:8, Oct:9, Nov:10, Dec:11 };
  const clean = dateStr.replace(/^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) /, "").replace(/ (AM|PM)$/, "");
  const parts = clean.split(" ");
  const day = parseInt(parts[0]);
  const month = months[parts[1]];
  const sessionDate = new Date(2026, month, day, 12, 0);
  return sessionDate < new Date();
};

const RainbowHeading = ({ children, size = 28, tag = "h2" }) => {
  const s = {
    fontFamily: heading, fontSize: size, fontWeight: 800, textAlign: "center",
    lineHeight: 1.3, margin: 0,
    background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac}, ${C.pink})`,
    backgroundSize: "200% 100%",
    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
    backgroundClip: "text", animation: "rainbowSlide 4s linear infinite",
  };
  if (tag === "h1") return <h1 style={s}>{children}</h1>;
  if (tag === "h3") return <h3 style={s}>{children}</h3>;
  return <h2 style={s}>{children}</h2>;
};

const Nav = () => {
  const links = ["Home", "Meet The Bunch", "Classes", "Gallery", "Reviews", "Parties", "Merch", "Schools", "Contact"];
  return (
    <nav style={{
      background: C.cream, padding: "10px 24px",
      position: "sticky", top: 0, zIndex: 100,
      borderBottom: `2px solid ${C.pink}15`,
      boxShadow: "0 2px 16px rgba(0,0,0,0.03)",
    }}>
      <div style={{
        maxWidth: 900, margin: "0 auto",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <img src={IMG.logo} alt="The Funky Bunch" style={{ height: 46, objectFit: "contain", cursor: "pointer" }} onClick={() => { window.location.hash = "home"; }} />
        <div style={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
          {links.map(l => (
            <span key={l} style={{
              fontSize: 11.5, fontFamily: body, fontWeight: 600,
              color: l === "Classes" ? C.pink : C.ink + "88",
              padding: "5px 9px", borderRadius: 14,
              background: l === "Classes" ? C.pinkSoft : "transparent",
              cursor: "pointer",
            }} onClick={() => { window.location.hash = navMap[l]; }}>{l}</span>
          ))}
          <span style={{
            background: C.pink, color: "#fff", padding: "7px 18px",
            borderRadius: 50, fontFamily: heading, fontWeight: 700, fontSize: 12,
            cursor: "pointer", marginLeft: 4,
          }} onClick={() => { window.location.hash = "classes"; }}>Book Now</span>
        </div>
      </div>
    </nav>
  );
};

const Footer = () => (
  <footer style={{ background: C.cream, padding: "36px 24px 20px", borderTop: `2px solid ${C.pink}15` }}>
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 28, marginBottom: 24 }}>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Find Us</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>
            Lumina Dance Company<br />Eden Business Centre<br />South Stour Ave, Ashford<br />Kent TN23 7RS
          </div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Classes</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Term-time Thursdays<br />10:30 – 11:15</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Get in Touch</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>thefunkybunchashford@gmail.com</div>
          <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
            <a href="https://www.facebook.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.blue}><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg></a>
            <a href="https://www.instagram.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.pink}><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg></a>
          </div>
        </div>
      </div>
      <div style={{ height: 3, borderRadius: 2, marginBottom: 14, background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac})` }} />
      <div style={{ fontFamily: body, fontSize: 10, color: C.ink + "55", textAlign: "center" }}>© 2026 The Funky Bunch Kent. All rights reserved.</div>
    </div>
  </footer>
);

/* ═══ BOOKING PAGE ═══ */
export default function BookingPage() {
  const [mode, setMode] = useState(null); // null, 'single', 'term'
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [selectedDates, setSelectedDates] = useState([]);
  const [children, setChildren] = useState([{ name: "", age: "" }]);
  const [discountCode, setDiscountCode] = useState("");
  const [discountApplied, setDiscountApplied] = useState(false);
  const [discountInfo, setDiscountInfo] = useState(null);
  const [discountError, setDiscountError] = useState("");
  const [showCheckout, setShowCheckout] = useState(false);
  const [parentName, setParentName] = useState("");
  const [parentEmail, setParentEmail] = useState("");
  const [parentPhone, setParentPhone] = useState("");
  const [heardAbout, setHeardAbout] = useState("");
  const [heardAboutOther, setHeardAboutOther] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [photoConsent, setPhotoConsent] = useState("");
  const [allergies, setAllergies] = useState("");
  const [checkoutProcessing, setCheckoutProcessing] = useState(false);
  const [checkoutError, setCheckoutError] = useState("");
  const [halloweenPopup, setHalloweenPopup] = useState(false);
  const [halloweenStep, setHalloweenStep] = useState(0);

  // Real capacity from the server
  const [availability, setAvailability] = useState({});
  const [capacityLoaded, setCapacityLoaded] = useState(false);

  useEffect(() => {
    fetch("/.netlify/functions/check-capacity")
      .then(r => r.json())
      .then(d => {
        setAvailability(d.availability || {});
        setCapacityLoaded(true);
      })
      .catch(() => setCapacityLoaded(true));
  }, []);

  // Returns available spots for a given date. If not in availability map, it has never been booked so full capacity is available.
  const getSpots = (date) => {
    if (FORCED_FULL[date]) return 0;
    const cap = SESSION_CAPACITY[date] ?? MAX_CAPACITY;
    if (date in availability) return Math.max(0, cap - (MAX_CAPACITY - availability[date]));
    return cap;
  };

  const toggleDate = (date) => {
    setSelectedDates(prev =>
      prev.includes(date) ? prev.filter(d => d !== date) : [...prev, date]
    );
  };

  const selectTerm = (termIdx) => {
    setSelectedTerm(termIdx);
    setSelectedDates(terms[termIdx].dates.map(d => d.date));
  };

  const addChild = () => setChildren([...children, { name: "", age: "" }]);
  const removeChild = (idx) => setChildren(children.filter((_, i) => i !== idx));
  const updateChild = (idx, field, val) => {
    const updated = [...children];
    updated[idx][field] = val;
    setChildren(updated);
  };

  const validChildren = children.filter(c => c.name.trim() !== "");
  const numChildren = Math.max(validChildren.length, 1);

  // Check if any selected date is over capacity for the number of children
  const capacityErrors = selectedDates.filter(date => getSpots(date) < numChildren);

  // Effective booking type: the Easter Holiday Special is always drop-in regardless of mode
  const effectiveMode = mode === "term" && selectedTerm !== null && !terms[selectedTerm].special ? "term" : "drop-in";

  const calcTotal = () => {
    const isHalloweenSelected = selectedDates.includes("Thu 29 Oct");
    const pricePerSession = isHalloweenSelected ? 10 : PRICE_SINGLE;
    let numSessions, fullPrice, termDiscount;
    if (effectiveMode === "term" && selectedTerm !== null) {
      numSessions = terms[selectedTerm].dates.length;
      fullPrice = numSessions * pricePerSession * numChildren;
      termDiscount = fullPrice * DISCOUNT;
    } else {
      numSessions = selectedDates.length;
      fullPrice = numSessions * pricePerSession * numChildren;
      termDiscount = 0;
    }
    let afterTerm = fullPrice - termDiscount;
    let codeDiscount = 0;
    if (discountApplied && discountInfo) {
      const dType = (discountInfo.type || "").trim().toLowerCase();
      if (dType === "referral") {
        codeDiscount = effectiveMode === "term" ? 7 : 3.50;
      } else if (dType === "percentage") {
        codeDiscount = afterTerm * (discountInfo.amount / 100);
      } else if (dType === "fixed") {
        codeDiscount = Math.min(discountInfo.amount, afterTerm);
      }
    }
    const total = Math.max(0, afterTerm - codeDiscount);
    return { full: fullPrice, discount: termDiscount, codeDiscount, total, sessions: numSessions, pricePerSession };
  };

  const pricing = calcTotal();

  const reset = () => {
    setMode(null);
    setSelectedTerm(null);
    setSelectedDates([]);
    setChildren([{ name: "", age: "" }]);
    setDiscountCode("");
    setDiscountApplied(false);
    setShowCheckout(false);
    setParentName("");
    setParentEmail("");
    setParentPhone("");
    setHeardAbout("");
    setHeardAboutOther("");
    setAgreeTerms(false);
    setPhotoConsent("");
    setAllergies("");
    setCheckoutError("");
  };

  return (
    <div style={{ background: C.cream, minHeight: "100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Nunito:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        @keyframes idleWobble {
          0%, 100% { transform: rotate(0deg) scaleX(1) scaleY(1); }
          20% { transform: rotate(-3deg) scaleX(1.02) scaleY(0.98); }
          50% { transform: rotate(3deg) scaleX(0.98) scaleY(1.02); }
          80% { transform: rotate(-2deg) scaleX(1.01) scaleY(0.99); }
        }
        @keyframes dizzyDottie {
          0% { transform: rotate(0deg) scale(1); }
          25% { transform: rotate(90deg) scale(1.04); }
          50% { transform: rotate(180deg) scale(1); }
          75% { transform: rotate(270deg) scale(1.04); }
          100% { transform: rotate(360deg) scale(1); }
        }
        @keyframes specialPulse {
          0%, 100% { transform: scale(1); box-shadow: 0 0 10px rgba(247,161,196,0.15); }
          50% { transform: scale(1.03); box-shadow: 0 0 20px rgba(247,161,196,0.35); }
        }
        @keyframes rainbowSlide {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        button:hover { transform: scale(1.03); transition: transform 0.2s; }
        button:active { transform: scale(0.98); }
        input { font-family: 'Nunito', sans-serif; }
      `}</style>

      <Nav />

      {/* ── Halloween Spooktacular Popup ── */}
      {halloweenPopup && (
        <div style={{
          position: "fixed", inset: 0, background: "rgba(31,20,50,0.75)",
          zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center",
          padding: 24,
        }} onClick={e => { if (e.target === e.currentTarget) { setHalloweenPopup(false); setHalloweenStep(0); } }}>
          <div style={{
            background: "linear-gradient(160deg, #2d1b4e 0%, #1a0a2e 100%)",
            borderRadius: 28, padding: "32px 28px",
            maxWidth: 440, width: "100%",
            boxShadow: "0 8px 48px rgba(0,0,0,0.6), 0 0 40px #D7B7F640",
            position: "relative", overflow: "hidden",
            border: "2px solid #D7B7F640",
          }}>
            <div style={{ position: "absolute", top: 10, left: 16, fontSize: 22, opacity: 0.7 }}>🕷️</div>
            <div style={{ position: "absolute", top: 10, right: 16, fontSize: 22, opacity: 0.7 }}>🕸️</div>
            <div style={{ position: "absolute", bottom: 14, left: 20, fontSize: 18, opacity: 0.5 }}>🎃</div>
            <div style={{ position: "absolute", bottom: 14, right: 20, fontSize: 18, opacity: 0.5 }}>🎃</div>
            <button onClick={() => { setHalloweenPopup(false); setHalloweenStep(0); }} style={{
              position: "absolute", top: 14, right: 18,
              background: "none", border: "none", fontSize: 20,
              color: "#fff6", cursor: "pointer",
            }}>✕</button>
            <div style={{ textAlign: "center", marginBottom: 16 }}>
              <div style={{ fontFamily: heading, fontSize: 32, fontWeight: 800, color: "#fff", textShadow: "0 2px 0 #000, 0 4px 12px #0008", letterSpacing: 1, lineHeight: 1.1, marginBottom: 4 }}>HALLOWEEN</div>
              <div style={{ fontFamily: heading, fontSize: 26, fontWeight: 800, background: "linear-gradient(90deg, #F7A1C4, #FFD966, #9ED9C3, #9CCBFF, #D7B7F6)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>SPOOKTACULAR! 👻</div>
            </div>
            <div style={{ textAlign: "center", fontSize: 38, marginBottom: 16, letterSpacing: 8 }}>🧙‍♀️ 🧛 🧟 👻 🦇</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center", marginBottom: 20 }}>
              {[["📅 Thu 29 October", "#D7B7F6"], ["⏰ 10:30 – 11:30am", "#9CCBFF"], ["👶 Ages 3–8", "#F7A1C4"], ["🎭 Dress up encouraged!", "#FFD966"], ["💰 £10 per child", "#9ED9C3"]].map(function(item, i) { return (
                <div key={i} style={{ background: item[1] + "22", border: "1px solid " + item[1] + "66", color: item[1], padding: "6px 14px", borderRadius: 20, fontFamily: heading, fontWeight: 700, fontSize: 12 }}>{item[0]}</div>
              ); })}
            </div>
            <div style={{ background: "#ffffff12", borderRadius: 16, padding: "14px 16px", marginBottom: 20, border: "1px solid #ffffff15" }}>
              <p style={{ fontFamily: body, fontSize: 14, color: "#ffffffcc", lineHeight: 1.7, margin: 0 }}>
                Get ready for our spookiest session yet! Expect dancing, party games and Halloween fun for little ones aged 3–8. Dress up is encouraged — the more creative the better!
              </p>
            </div>
            {halloweenStep === 0 ? (
              <button onClick={() => setHalloweenStep(1)} style={{
                width: "100%", padding: "16px",
                background: "linear-gradient(135deg, #D7B7F6, #F7A1C4)",
                color: "#fff", border: "none", borderRadius: 50,
                fontFamily: heading, fontWeight: 700, fontSize: 16,
                cursor: "pointer", boxShadow: "0 4px 20px #D7B7F655",
              }}>
                🎃 Book Now — £10 per child
              </button>
            ) : (
              <div>
                <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 15, color: "#fff", marginBottom: 10 }}>Who is attending? <span style={{ fontFamily: body, fontWeight: 400, fontSize: 12, color: "#ffffff88" }}>(Ages 3–8)</span></div>
                {children.map(function(child, i) { return (
                  <div key={i} style={{ display: "flex", gap: 8, marginBottom: 8, alignItems: "center" }}>
                    <div style={{ width: 26, height: 26, borderRadius: "50%", background: "#D7B7F633", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: heading, fontWeight: 700, fontSize: 11, color: "#D7B7F6", flexShrink: 0 }}>{i + 1}</div>
                    <input placeholder="Child's name" value={child.name} onChange={function(e) { const u = [...children]; u[i].name = e.target.value; setChildren(u); }} style={{ flex: 2, padding: "9px 12px", borderRadius: 10, border: "1.5px solid #D7B7F640", fontSize: 13, outline: "none", background: "#ffffff15", fontFamily: body, color: "#fff" }} />
                    <input placeholder="Age" value={child.age} type="number" min="3" max="8" onChange={function(e) { const u = [...children]; u[i].age = e.target.value; setChildren(u); }} style={{ flex: 0.6, padding: "9px 10px", borderRadius: 10, border: "1.5px solid #D7B7F640", fontSize: 13, outline: "none", background: "#ffffff15", fontFamily: body, color: "#fff" }} />
                    {children.length > 1 && <span onClick={function() { setChildren(children.filter(function(_, j) { return j !== i; })); }} style={{ cursor: "pointer", color: "#ffffff66", fontSize: 16 }}>✕</span>}
                  </div>
                ); })}
                {children.length < 5 && <div onClick={function() { setChildren([...children, { name: "", age: "" }]); }} style={{ fontFamily: body, fontSize: 12, color: "#D7B7F6", cursor: "pointer", fontWeight: 600, marginBottom: 12 }}>+ Add another child</div>}
                <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                  <button onClick={() => setHalloweenStep(0)} style={{ flex: 1, padding: "12px", background: "transparent", color: "#ffffffaa", border: "1.5px solid #ffffff33", borderRadius: 50, fontFamily: heading, fontWeight: 700, fontSize: 14, cursor: "pointer" }}>Back</button>
                  <button onClick={() => {
                    const valid = children.filter(c => c.name.trim());
                    if (valid.length === 0) return;
                    setHalloweenPopup(false);
                    setHalloweenStep(0);
                    setMode("single");
                    setSelectedTerm(null);
                    setSelectedDates(["Thu 29 Oct"]);
                    setChildren(valid.length > 0 ? valid : [{ name: "", age: "" }]);
                    setShowCheckout(true);
                  }} style={{ flex: 2, padding: "12px", background: "linear-gradient(135deg, #D7B7F6, #F7A1C4)", color: "#fff", border: "none", borderRadius: 50, fontFamily: heading, fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
                    Continue to booking →
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Hero */}
      <section style={{
        background: `linear-gradient(180deg, ${C.cream} 0%, ${C.blueSoft} 100%)`,
        padding: "48px 24px 40px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={28}>Book Your Spot</RainbowHeading>
          <p style={{
            fontFamily: body, fontSize: 15, color: C.ink + "aa",
            lineHeight: 1.6, margin: "8px auto 0", maxWidth: 440,
          }}>
            Choose a single class or save 10% with a full term booking
          </p>
        </div>
      </section>

      {/* Main content */}
      <section style={{ padding: "0 24px 56px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>

          {/* Pricing cards */}
          <div id="booking-start" style={{
            display: "flex", gap: 20, justifyContent: "center",
            flexWrap: "wrap", marginTop: -20, marginBottom: 36,
          }}>
            {/* Single class card */}
            <div
              onClick={() => { setMode("single"); setSelectedTerm(null); setSelectedDates([]); }}
              style={{
                flex: "1 1 260px", maxWidth: 320,
                background: mode === "single" ? C.blueSoft : "#fff",
                borderRadius: 24, padding: "32px 28px", textAlign: "center",
                border: `3px solid ${mode === "single" ? C.blue : C.blue + "30"}`,
                cursor: "pointer", transition: "all 0.3s ease",
              }}
            >
              <div style={{ fontSize: 13, fontFamily: body, fontWeight: 700, color: C.ink + "77", marginBottom: 4 }}>DROP-IN</div>
              <div style={{ fontFamily: heading, fontSize: 42, fontWeight: 800, color: C.ink }}>
                £{PRICE_SINGLE}
              </div>
              <div style={{ fontSize: 13, fontFamily: body, color: C.ink + "88", marginBottom: 16 }}>per child, per class</div>
              <div style={{
                background: mode === "single" ? C.blue : C.blue + "33",
                color: mode === "single" ? "#fff" : C.ink,
                padding: "10px 24px", borderRadius: 50,
                fontFamily: heading, fontWeight: 700, fontSize: 14,
                display: "inline-block", transition: "all 0.3s",
              }}>
                {mode === "single" ? "Selected" : "Choose dates"}
              </div>
            </div>

            {/* Term card */}
            <div
              onClick={() => { setMode("term"); setSelectedDates([]); }}
              style={{
                flex: "1 1 260px", maxWidth: 320,
                background: mode === "term" ? C.pinkSoft : "#fff",
                borderRadius: 24, padding: "32px 28px", textAlign: "center",
                border: `3px solid ${mode === "term" ? C.pink : C.pink + "30"}`,
                cursor: "pointer", transition: "all 0.3s ease",
                position: "relative",
              }}
            >
              <div style={{
                position: "absolute", top: -10, right: 20,
                background: C.pink, color: "#fff", fontSize: 11,
                fontFamily: heading, fontWeight: 700, padding: "3px 14px",
                borderRadius: 20,
              }}>SAVE 10%</div>
              <div style={{ fontSize: 13, fontFamily: body, fontWeight: 700, color: C.ink + "77", marginBottom: 4 }}>FULL TERM</div>
              <div style={{ fontFamily: heading, fontSize: 42, fontWeight: 800, color: C.ink }}>
                10% off
              </div>
              <div style={{ fontSize: 13, fontFamily: body, color: C.ink + "88", marginBottom: 16 }}>per child, whole term</div>
              <div style={{
                background: mode === "term" ? C.pink : C.pink + "33",
                color: mode === "term" ? "#fff" : C.ink,
                padding: "10px 24px", borderRadius: 50,
                fontFamily: heading, fontWeight: 700, fontSize: 14,
                display: "inline-block", transition: "all 0.3s",
              }}>
                {mode === "term" ? "Selected" : "Choose a term"}
              </div>
            </div>
          </div>

          {/* Date selection */}
          {mode && (
            <div style={{ animation: "fadeIn 0.4s ease", marginBottom: 32 }}>
              <h3 style={{ fontFamily: heading, fontSize: 20, fontWeight: 800, color: C.ink, marginBottom: 16, textAlign: "center" }}>
                {mode === "single" ? "Select your dates" : "Choose your term"}
              </h3>

              {terms.map((term, tIdx) => {
                const isSpecial = !!term.special;
                const isHalloween = !!term.halloween;
                // Hide the entire term if every session in it is in the past
                const hasUpcomingDates = term.dates.some(d => !isDatePast(d.date));
                if (!hasUpcomingDates) return null;
                // In term mode, hide the "Book this term" button for special sessions
                const showTermButton = mode === "term" && !isSpecial;

                // Halloween Spooktacular renders as a special featured dark card
                if (isHalloween) {
                  return (
                    <div key={tIdx} style={{ marginBottom: 24 }}>
                      <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 16, color: C.ink, marginBottom: 10 }}>
                        Halloween Spooktacular
                        <span style={{ fontFamily: body, fontWeight: 400, fontSize: 13, color: C.ink + "77", marginLeft: 8 }}>1 session</span>
                        <span style={{ fontFamily: body, fontWeight: 600, fontSize: 11, color: C.pink, background: C.pinkSoft, padding: "2px 10px", borderRadius: 20, marginLeft: 8 }}>Drop-in only</span>
                      </div>
                      <div
                        onClick={() => setHalloweenPopup(true)}
                        style={{
                          background: "linear-gradient(135deg, #2d1b4e, #4a1e6b)",
                          borderRadius: 20, padding: "20px 22px",
                          cursor: "pointer", border: "2px solid #D7B7F660",
                          boxShadow: "0 4px 24px #D7B7F630",
                          display: "flex", alignItems: "center", justifyContent: "space-between",
                          flexWrap: "wrap", gap: 12,
                          transition: "transform 0.2s, box-shadow 0.2s",
                        }}
                        onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 32px #D7B7F650"; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 24px #D7B7F630"; }}
                      >
                        <div>
                          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
                            <span style={{ fontSize: 28 }}>🎃</span>
                            <div>
                              <div style={{ fontFamily: heading, fontWeight: 800, fontSize: 18, color: "#fff", lineHeight: 1.2 }}>Thu 29 October</div>
                              <div style={{ fontFamily: body, fontSize: 13, color: "#D7B7F6", marginTop: 2 }}>10:30 – 11:30 · Ages 3–8 · £10 per child</div>
                            </div>
                          </div>
                          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                            {["👻 Disco", "🎭 Dress up!", "🕷️ Party games"].map(function(t, i) { return (
                              <span key={i} style={{ background: "#ffffff15", color: "#ffffffcc", padding: "3px 10px", borderRadius: 20, fontFamily: body, fontSize: 11, fontWeight: 600 }}>{t}</span>
                            ); })}
                          </div>
                        </div>
                        <div style={{
                          background: "linear-gradient(135deg, #D7B7F6, #F7A1C4)",
                          color: "#fff", padding: "10px 20px", borderRadius: 50,
                          fontFamily: heading, fontWeight: 700, fontSize: 13,
                          whiteSpace: "nowrap",
                        }}>
                          Find out more →
                        </div>
                      </div>
                    </div>
                  );
                }

                return (
                  <div key={tIdx} style={{ marginBottom: 20 }}>
                    <div style={{
                      display: "flex", alignItems: "center", justifyContent: "space-between",
                      marginBottom: 10,
                    }}>
                      <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 16, color: C.ink }}>
                        {term.name}
                        <span style={{ fontFamily: body, fontWeight: 400, fontSize: 13, color: C.ink + "77", marginLeft: 8 }}>
                          {term.dates.length} {isSpecial ? "session" : term.dates.length === 1 ? "session" : "weeks"}
                        </span>
                        {isSpecial && (
                          <span style={{
                            fontFamily: body, fontWeight: 600, fontSize: 11,
                            color: C.pink, background: C.pinkSoft,
                            padding: "2px 10px", borderRadius: 20, marginLeft: 8,
                          }}>Drop-in only</span>
                        )}
                      </div>
                      {showTermButton && (
                        <button
                          onClick={() => selectTerm(tIdx)}
                          style={{
                            background: selectedTerm === tIdx ? C.pink : "transparent",
                            color: selectedTerm === tIdx ? "#fff" : C.pink,
                            border: `2px solid ${C.pink}`,
                            padding: "6px 18px", borderRadius: 50,
                            fontFamily: heading, fontWeight: 700, fontSize: 12,
                            cursor: "pointer",
                          }}
                        >
                          {selectedTerm === tIdx ? "Selected" : "Book this term"}
                        </button>
                      )}
                    </div>

                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      {term.dates.map((d, dIdx) => {
                        const spots = getSpots(d.date);
                        const isSelected = selectedDates.includes(d.date);
                        // In term mode, special sessions can still be clicked (drop-in); regular sessions are not clickable
                        const isClickable = mode === "single" || isSpecial;
                        const isPast = isDatePast(d.date);
                        const isFull = spots === 0;
                        const numValid = validChildren.length || 1;
                        const notEnoughSpace = spots < numValid && spots > 0;

                        if (isPast) return null;

                        return (
                          <div
                            key={dIdx}
                            onClick={() => {
                              if (!isClickable || isPast || isFull) return;
                              toggleDate(d.date);
                            }}
                            style={{
                              background: isFull ? "#f5f5f5" : isSelected ? C.blue + "25" : "#fff",
                              border: `2px solid ${isFull ? "#ddd" : isSelected ? C.blue : "#eee"}`,
                              borderRadius: 14, padding: "10px 14px",
                              cursor: isClickable && !isPast && !isFull ? "pointer" : "default",
                              transition: "all 0.2s",
                              minWidth: 120,
                              position: "relative",
                              opacity: isFull ? 0.6 : 1,
                            }}
                          >
                            {d.label && (
                              <div style={{
                                fontSize: 9, fontFamily: heading, fontWeight: 700,
                                color: "#fff", background: C.pink,
                                borderRadius: 8, padding: "2px 8px",
                                position: "absolute", top: -8, left: 10,
                              }}>{d.label}</div>
                            )}
                            <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 13, color: C.ink }}>
                              {d.displayLabel || d.date}
                            </div>
                            <div style={{ fontFamily: body, fontSize: 11, color: d.special ? C.pink : C.ink + "77" }}>
                              {d.special
                                ? (d.time || (d.date.endsWith(" PM") ? "12:30 – 13:30" : "10:30 – 11:30"))
                                : "10:30 – 11:15"}
                            </div>
                            <div style={{
                              fontFamily: body, fontSize: 11, fontWeight: 600, marginTop: 4,
                              color: isFull ? "#e74c3c" : spots <= 5 ? "#e07000" : C.mint + "88",
                            }}>
                              {isFull ? "Fully booked" : spots <= 5 ? `Only ${spots} spot${spots === 1 ? "" : "s"} left` : "Spaces available"}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Children & checkout section */}
          {selectedDates.length > 0 && (
            <div style={{
              display: "flex", gap: 28, flexWrap: "wrap",
              justifyContent: "center", animation: "fadeIn 0.4s ease",
            }}>
              {/* Left: form */}
              <div style={{ flex: "1 1 380px", maxWidth: 500 }}>
                {/* Children details */}
                <div style={{
                  background: "#fff", borderRadius: 24,
                  border: `2px solid ${C.blue}20`,
                  padding: "28px 24px", marginBottom: 20,
                }}>
                  <h3 style={{ fontFamily: heading, fontSize: 18, fontWeight: 800, color: C.ink, marginBottom: 16 }}>
                    Who's dancing?
                  </h3>
                  {children.map((child, idx) => (
                    <div key={idx} style={{
                      display: "flex", gap: 10, marginBottom: 12, alignItems: "center",
                    }}>
                      <div style={{
                        width: 28, height: 28, borderRadius: "50%",
                        background: [C.pink, C.blue, C.mint, C.yellow, C.lilac][idx % 5] + "33",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontFamily: heading, fontWeight: 700, fontSize: 12,
                        color: [C.pink, C.blue, C.mint, C.yellow, C.lilac][idx % 5],
                        flexShrink: 0,
                      }}>{idx + 1}</div>
                      <input
                        type="text"
                        placeholder="Child's name"
                        value={child.name}
                        onChange={e => updateChild(idx, "name", e.target.value)}
                        style={{
                          flex: 1, padding: "10px 14px", borderRadius: 12,
                          border: `1.5px solid ${C.blue}30`, fontSize: 14,
                          outline: "none", background: C.cream,
                        }}
                      />
                      <input
                        type="text"
                        placeholder="Age"
                        value={child.age}
                        onChange={e => updateChild(idx, "age", e.target.value)}
                        style={{
                          width: 60, padding: "10px 14px", borderRadius: 12,
                          border: `1.5px solid ${C.blue}30`, fontSize: 14,
                          outline: "none", background: C.cream, textAlign: "center",
                        }}
                      />
                      {children.length > 1 && (
                        <button
                          onClick={() => removeChild(idx)}
                          style={{
                            width: 28, height: 28, borderRadius: "50%",
                            background: C.pinkSoft, border: "none",
                            color: C.pink, fontSize: 16, cursor: "pointer",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            fontWeight: 700,
                          }}
                        >×</button>
                      )}
                    </div>
                  ))}
                  <button
                    onClick={addChild}
                    style={{
                      background: "transparent", border: `2px dashed ${C.blue}44`,
                      borderRadius: 12, padding: "10px", width: "100%",
                      fontFamily: body, fontWeight: 600, fontSize: 13,
                      color: C.blue, cursor: "pointer", marginTop: 4,
                    }}
                  >
                    + Add another child
                  </button>

                  {/* Capacity warning */}
                  {capacityErrors.length > 0 && (
                    <div style={{
                      marginTop: 14, padding: "12px 16px", borderRadius: 12,
                      background: "#fff3f3", border: "1.5px solid #e74c3c33",
                    }}>
                      <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 13, color: "#e74c3c", marginBottom: 4 }}>
                        Not enough space available
                      </div>
                      {capacityErrors.map(date => (
                        <div key={date} style={{ fontFamily: body, fontSize: 12, color: "#e74c3c" }}>
                          {date}: only {getSpots(date)} spot{getSpots(date) === 1 ? "" : "s"} left
                        </div>
                      ))}
                      <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", marginTop: 6 }}>
                        Please reduce the number of children or choose a different date.
                      </div>
                    </div>
                  )}
                </div>

                {/* Discount code */}
                <div style={{
                  background: "#fff", borderRadius: 24,
                  border: `2px solid ${C.yellow}20`,
                  padding: "20px 24px", marginBottom: 20,
                }}>
                  <div style={{ fontFamily: heading, fontSize: 15, fontWeight: 700, color: C.ink, marginBottom: 10 }}>
                    Got a discount code?
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <input
                      type="text"
                      placeholder="Enter code"
                      value={discountCode}
                      onChange={e => { setDiscountCode(e.target.value); setDiscountApplied(false); }}
                      style={{
                        flex: 1, padding: "10px 14px", borderRadius: 12,
                        border: `1.5px solid ${C.yellow}40`, fontSize: 14,
                        outline: "none", background: C.cream,
                      }}
                    />
                    <button
                      onClick={async () => {
                        if (!discountCode.trim()) return;
                        setDiscountError("");
                        try {
                          const res = await fetch("/.netlify/functions/validate-discount", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ code: discountCode.trim(), bookingType: effectiveMode }),
                          });
                          const data = await res.json();
                          if (data.valid) {
                            setDiscountApplied(true);
                            setDiscountInfo(data);
                          } else {
                            setDiscountApplied(false);
                            setDiscountInfo(null);
                            setDiscountError(data.reason || "Invalid code");
                          }
                        } catch (e) {
                          setDiscountError("Could not validate code");
                        }
                      }}
                      style={{
                        background: C.yellow, color: C.ink, border: "none",
                        padding: "10px 20px", borderRadius: 12,
                        fontFamily: heading, fontWeight: 700, fontSize: 13,
                        cursor: "pointer",
                      }}
                    >Apply</button>
                  </div>
                  {discountApplied && discountInfo && (
                    <div style={{
                      fontFamily: body, fontSize: 12, color: C.mint,
                      fontWeight: 600, marginTop: 8,
                    }}>
                      Code applied! {discountInfo.type === "referral" ? "£3.50 off drop-in or £7 off term" : discountInfo.type === "percentage" ? `${discountInfo.amount}% off` : `£${discountInfo.amount.toFixed(2)} off`}
                    </div>
                  )}
                  {discountError && (
                    <div style={{
                      fontFamily: body, fontSize: 12, color: "#e74c3c",
                      fontWeight: 600, marginTop: 8,
                    }}>
                      {discountError}
                    </div>
                  )}
                </div>
              </div>

              {/* Right: summary + Dottie */}
              <div style={{ flex: "1 1 280px", maxWidth: 340 }}>
                {/* Order summary */}
                <div style={{
                  background: "#fff", borderRadius: 24,
                  border: `2px solid ${C.mint}20`,
                  padding: "28px 24px", marginBottom: 20,
                }}>
                  <h3 style={{ fontFamily: heading, fontSize: 18, fontWeight: 800, color: C.ink, marginBottom: 16 }}>
                    Your booking
                  </h3>

                  <div style={{ fontFamily: body, fontSize: 13, color: C.ink + "99", lineHeight: 2 }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Type</span>
                      <span style={{ fontWeight: 700, color: C.ink }}>{effectiveMode === "term" ? `Term booking` : "Drop-in"}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Sessions</span>
                      <span style={{ fontWeight: 700, color: C.ink }}>{pricing.sessions}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Children</span>
                      <span style={{ fontWeight: 700, color: C.ink }}>{numChildren}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>{pricing.sessions} × £{pricing.pricePerSession} × {numChildren}</span>
                      <span style={{ fontWeight: 700, color: C.ink }}>£{pricing.full.toFixed(2)}</span>
                    </div>
                    {pricing.discount > 0 && (
                      <div style={{ display: "flex", justifyContent: "space-between", color: C.mint }}>
                        <span>Term discount (10%)</span>
                        <span style={{ fontWeight: 700 }}>-£{pricing.discount.toFixed(2)}</span>
                      </div>
                    )}
                    {pricing.codeDiscount > 0 && (
                      <div style={{ display: "flex", justifyContent: "space-between", color: C.pink }}>
                        <span>Discount code ({discountCode})</span>
                        <span style={{ fontWeight: 700 }}>-£{pricing.codeDiscount.toFixed(2)}</span>
                      </div>
                    )}
                  </div>

                  {/* Total */}
                  <div style={{
                    marginTop: 16, paddingTop: 16,
                    borderTop: `2px solid ${C.cream}`,
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                  }}>
                    <span style={{ fontFamily: heading, fontSize: 16, fontWeight: 700, color: C.ink }}>Total</span>
                    <span style={{ fontFamily: heading, fontSize: 28, fontWeight: 800, color: C.ink }}>
                      £{pricing.total.toFixed(2)}
                    </span>
                  </div>

                  {/* Checkout button */}
                  <button
                    onClick={() => {
                      const valid = children.filter(c => c.name.trim() !== "");
                      if (valid.length === 0) { alert("Please add at least one child"); return; }
                      if (effectiveMode === "term" && selectedTerm === null) { alert("Please select a term"); return; }
                      if (effectiveMode !== "term" && selectedDates.length === 0) { alert("Please select at least one date"); return; }
                      if (capacityErrors.length > 0) {
                        alert("One or more of your selected dates does not have enough spaces available. Please reduce the number of children or choose different dates.");
                        return;
                      }
                      setShowCheckout(true);
                    }}
                    style={{
                      width: "100%", marginTop: 20,
                      background: capacityErrors.length > 0 ? C.ink + "33" : C.mint,
                      color: "#fff", border: "none",
                      padding: "16px", borderRadius: 50,
                      fontFamily: heading, fontWeight: 700, fontSize: 16,
                      cursor: capacityErrors.length > 0 ? "not-allowed" : "pointer",
                      boxShadow: capacityErrors.length > 0 ? "none" : `0 4px 16px ${C.mint}55`,
                    }}
                  >
                    Proceed to Payment
                  </button>
                  <div style={{
                    textAlign: "center", marginTop: 10,
                    fontFamily: body, fontSize: 11, color: C.ink + "66",
                  }}>
                    Secure payment powered by Stripe
                  </div>
                </div>

                {/* Dottie */}
                <div style={{ textAlign: "center" }}>
                  <div style={{
                    width: 140, height: 140, margin: "0 auto",
                    animation: "dizzyDottie 2s ease-in-out infinite",
                    transformOrigin: "center center",
                  }}>
                    <img src={IMG.dottie} alt="Dottie" style={{
                      width: "100%", height: "100%", objectFit: "contain",
                      filter: `drop-shadow(0 4px 12px ${C.blue}33)`,
                    }} />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Checkout modal overlay */}
          {showCheckout && (
            <div style={{
              position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
              display: "flex", alignItems: "center", justifyContent: "center",
              zIndex: 200, padding: 24,
              overflowY: "auto",
            }} onClick={() => setShowCheckout(false)}>
              <div
                onClick={e => e.stopPropagation()}
                style={{
                  background: "#fff", borderRadius: 28, padding: "36px 28px",
                  maxWidth: 460, width: "100%",
                  animation: "fadeIn 0.3s ease",
                  margin: "auto",
                  maxHeight: "90vh", overflowY: "auto",
                }}
              >
                {/* Header */}
                <div style={{ textAlign: "center", marginBottom: 24 }}>
                  <div style={{
                    width: 60, height: 60, margin: "0 auto 12px",
                    animation: "idleWobble 1.8s ease-in-out infinite",
                    transformOrigin: "center bottom",
                  }}>
                    <img src={IMG.dottie} alt="Dottie" style={{ width: "100%", height: "100%", objectFit: "contain", cursor: "pointer" }} onClick={() => { window.location.hash = "home"; }} />
                  </div>
                  <div style={{ fontFamily: heading, fontSize: 20, fontWeight: 800, color: C.ink }}>
                    Almost there!
                  </div>
                  <div style={{ fontFamily: body, fontSize: 13, color: C.ink + "88", marginTop: 4 }}>
                    Just a few details before we send you to payment
                  </div>
                </div>

                {/* Parent details */}
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 10 }}>
                    Your details
                  </div>
                  <input
                    type="text" placeholder="Your name" value={parentName}
                    onChange={e => setParentName(e.target.value)}
                    style={{
                      width: "100%", padding: "11px 14px", borderRadius: 12,
                      border: `1.5px solid ${C.blue}30`, fontSize: 14,
                      outline: "none", background: C.cream, marginBottom: 10,
                      fontFamily: body,
                    }}
                  />
                  <input
                    type="email" placeholder="Email address" value={parentEmail}
                    onChange={e => setParentEmail(e.target.value)}
                    style={{
                      width: "100%", padding: "11px 14px", borderRadius: 12,
                      border: `1.5px solid ${C.blue}30`, fontSize: 14,
                      outline: "none", background: C.cream, marginBottom: 10,
                      fontFamily: body,
                    }}
                  />
                  <input
                    type="tel" placeholder="Phone number" value={parentPhone}
                    onChange={e => setParentPhone(e.target.value)}
                    style={{
                      width: "100%", padding: "11px 14px", borderRadius: 12,
                      border: `1.5px solid ${C.blue}30`, fontSize: 14,
                      outline: "none", background: C.cream,
                      fontFamily: body,
                    }}
                  />
                </div>

                {/* How did you hear about us */}
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 10 }}>
                    Where did you hear about us?
                  </div>
                  <select
                    value={heardAbout}
                    onChange={e => { setHeardAbout(e.target.value); if (e.target.value !== "Other") setHeardAboutOther(""); }}
                    style={{
                      width: "100%", padding: "11px 14px", borderRadius: 12,
                      border: `1.5px solid ${C.blue}30`, fontSize: 14,
                      outline: "none", background: C.cream,
                      fontFamily: body, color: heardAbout ? C.ink : C.ink + "77",
                      appearance: "auto",
                    }}
                  >
                    <option value="" disabled>Please select...</option>
                    <option value="Facebook">Facebook</option>
                    <option value="Instagram">Instagram</option>
                    <option value="Word of Mouth">Word of Mouth</option>
                    <option value="Adverts/Fliers">Adverts / Fliers</option>
                    <option value="Other">Other (please specify)</option>
                  </select>
                  {heardAbout === "Other" && (
                    <input
                      type="text" placeholder="Please tell us where..."
                      value={heardAboutOther}
                      onChange={e => setHeardAboutOther(e.target.value)}
                      style={{
                        width: "100%", padding: "11px 14px", borderRadius: 12,
                        border: `1.5px solid ${C.blue}30`, fontSize: 14,
                        outline: "none", background: C.cream, marginTop: 10,
                        fontFamily: body,
                      }}
                    />
                  )}
                </div>

                {/* Discount code */}
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 10 }}>
                    Discount or referral code
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <input
                      type="text" placeholder="Enter code (optional)"
                      value={discountCode}
                      onChange={e => { setDiscountCode(e.target.value); setDiscountApplied(false); setDiscountError(""); }}
                      style={{
                        flex: 1, padding: "11px 14px", borderRadius: 12,
                        border: `1.5px solid ${C.blue}30`, fontSize: 14,
                        outline: "none", background: C.cream, fontFamily: body,
                      }}
                    />
                    <button onClick={async () => {
                      if (!discountCode.trim()) return;
                      try {
                        const res = await fetch("/.netlify/functions/validate-discount", {
                          method: "POST", headers: { "Content-Type": "application/json" },
                          body: JSON.stringify({ code: discountCode.trim(), bookingType: effectiveMode }),
                        });
                        const data = await res.json();
                        if (data.valid) { setDiscountApplied(true); setDiscountInfo(data); setDiscountError(""); }
                        else { setDiscountApplied(false); setDiscountInfo(null); setDiscountError(data.reason || "Invalid code"); }
                      } catch (e) { setDiscountError("Could not validate code"); }
                    }} style={{
                      background: C.yellow, color: C.ink, border: "none",
                      padding: "11px 18px", borderRadius: 12,
                      fontFamily: heading, fontWeight: 700, fontSize: 13, cursor: "pointer",
                    }}>Apply</button>
                  </div>
                  {discountApplied && <div style={{ fontFamily: body, fontSize: 12, color: C.mint, fontWeight: 600, marginTop: 6 }}>Code applied!</div>}
                  {discountError && <div style={{ fontFamily: body, fontSize: 12, color: "#e74c3c", fontWeight: 600, marginTop: 6 }}>{discountError}</div>}
                </div>

                {/* Checkboxes */}
                <div style={{ marginBottom: 24 }}>
                  {/* T&Cs - mandatory */}
                  <label style={{
                    display: "flex", gap: 10, alignItems: "flex-start",
                    cursor: "pointer", marginBottom: 14,
                  }}>
                    <div
                      onClick={() => setAgreeTerms(!agreeTerms)}
                      style={{
                        width: 22, height: 22, borderRadius: 6, flexShrink: 0, marginTop: 1,
                        border: `2px solid ${agreeTerms ? C.mint : checkoutError && !agreeTerms ? "#e74c3c" : C.ink + "33"}`,
                        background: agreeTerms ? C.mint : "#fff",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        transition: "all 0.2s",
                      }}
                    >
                      {agreeTerms && (
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      )}
                    </div>
                    <div>
                      <span style={{ fontFamily: body, fontSize: 13, color: C.ink, lineHeight: 1.5 }}>
                        I agree to the <a href="/terms-and-conditions.pdf" target="_blank" rel="noopener noreferrer" style={{ color: C.pink, fontWeight: 600, textDecoration: "underline", cursor: "pointer" }}>Terms & Conditions</a> *
                      </span>
                      {checkoutError && !agreeTerms && (
                        <div style={{ fontFamily: body, fontSize: 11, color: "#e74c3c", marginTop: 2 }}>
                          Please agree to the Terms & Conditions to continue
                        </div>
                      )}
                    </div>
                  </label>

                  {/* Photo consent - mandatory Yes/No */}
                  <div style={{ marginTop: 4 }}>
                    <div style={{ fontFamily: body, fontSize: 13, color: C.ink, marginBottom: 8 }}>
                      Can we use photos/videos of your child for promotional purposes? *
                    </div>
                    <div style={{ display: "flex", gap: 10 }}>
                      {["Yes", "No"].map(opt => {
                        const val = opt === "Yes" ? "true" : "false";
                        const selected = photoConsent === val;
                        return (
                          <button key={opt} type="button" onClick={() => setPhotoConsent(val)} style={{
                            flex: 1, padding: "11px 0", borderRadius: 12,
                            border: `2px solid ${selected ? C.mint : checkoutError && !photoConsent ? "#e74c3c" : C.ink + "22"}`,
                            background: selected ? C.mint : "#fff",
                            color: selected ? "#fff" : C.ink,
                            fontFamily: heading, fontWeight: 700, fontSize: 15,
                            cursor: "pointer", transition: "all 0.2s",
                          }}>{opt}</button>
                        );
                      })}
                    </div>
                    {checkoutError && !photoConsent && (
                      <div style={{ fontFamily: body, fontSize: 11, color: "#e74c3c", marginTop: 4 }}>
                        Please select Yes or No to continue
                      </div>
                    )}
                  </div>
                </div>

                {/* Allergies */}
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 8 }}>
                    Allergies or dietary requirements
                  </div>
                  <textarea
                    placeholder="Please let us know of any allergies or dietary requirements (or leave blank if none)"
                    value={allergies}
                    onChange={e => setAllergies(e.target.value)}
                    rows={3}
                    style={{
                      width: "100%", padding: "11px 14px", borderRadius: 12,
                      border: `1.5px solid ${C.blue}30`, fontSize: 13,
                      outline: "none", background: C.cream,
                      fontFamily: body, resize: "vertical",
                    }}
                  />
                </div>

                {/* Summary line */}
                <div style={{
                  background: C.cream, borderRadius: 14, padding: "14px 18px",
                  display: "flex", justifyContent: "space-between", alignItems: "center",
                  marginBottom: 20,
                }}>
                  <span style={{ fontFamily: body, fontSize: 13, color: C.ink + "88" }}>
                    {pricing.sessions} session{pricing.sessions > 1 ? "s" : ""} · {numChildren} child{numChildren > 1 ? "ren" : ""}
                  </span>
                  <span style={{ fontFamily: heading, fontSize: 22, fontWeight: 800, color: C.ink }}>
                    £{pricing.total.toFixed(2)}
                  </span>
                </div>

                {/* Buttons */}
                <div style={{ display: "flex", gap: 10 }}>
                  <button
                    onClick={() => { setShowCheckout(false); setCheckoutError(""); }}
                    style={{
                      flex: 1, background: "transparent", color: C.ink,
                      border: `2px solid ${C.ink}22`,
                      padding: "14px", borderRadius: 50,
                      fontFamily: heading, fontWeight: 700, fontSize: 14, cursor: "pointer",
                    }}
                  >Go Back</button>
                  <button
                    onClick={async () => {
                      if (!agreeTerms) {
                        setCheckoutError("Please agree to T&Cs");
                        return;
                      }
                      if (!photoConsent) {
                        setCheckoutError("Please select a photo consent option");
                        return;
                      }
                      try {
                        setCheckoutProcessing(true);
                        const res = await fetch("/.netlify/functions/create-checkout", {
                          method: "POST",
                          headers: { 
                            "Content-Type": "application/json",
                            "x-customer-email": parentEmail,
                          },
                          body: JSON.stringify({
                            bookingType: effectiveMode,
                            sessions: selectedDates,
                            children: children.filter(c => c.name.trim() !== ""),
                            discountCode: discountApplied ? discountCode : "",
                            termName: selectedTerm !== null ? terms[selectedTerm].name : "",
                            parentName,
                            parentPhone,
                            heardAbout: heardAbout === "Other" ? heardAboutOther : heardAbout,
                            photoConsent,
                            allergies,
                          }),
                        });
                        const data = await res.json();
                        if (data.free) {
                          window.location.hash = "booking-success";
                        } else if (data.url) {
                          window.location.href = data.url;
                        } else {
                          setCheckoutProcessing(false);
                          alert("Something went wrong. Please try again or contact us directly.");
                        }
                      } catch (err) {
                        setCheckoutProcessing(false);
                        alert("Something went wrong. Please try again or contact us directly.");
                      }
                    }}
                    style={{
                      flex: 1, background: agreeTerms && photoConsent && !checkoutProcessing ? C.mint : C.ink + "33", color: "#fff", border: "none",
                      padding: "14px", borderRadius: 50,
                      fontFamily: heading, fontWeight: 700, fontSize: 14, cursor: agreeTerms && photoConsent && !checkoutProcessing ? "pointer" : "default",
                      boxShadow: `0 4px 16px ${C.mint}55`,
                      opacity: agreeTerms && photoConsent && !checkoutProcessing ? 1 : 0.6,
                    }}
                    disabled={checkoutProcessing || !agreeTerms || !photoConsent}
                  >{checkoutProcessing ? "Processing..." : "Continue to Payment"}</button>
                </div>

                <div style={{
                  textAlign: "center", marginTop: 12,
                  fontFamily: body, fontSize: 11, color: C.ink + "55",
                }}>
                  Secure payment powered by Stripe
                </div>
              </div>
            </div>
          )}

          {/* Location section */}
          <div style={{
            background: "#fff", borderRadius: 24,
            border: `2px solid ${C.lilac}20`,
            padding: "28px 24px", marginTop: 36,
            textAlign: "center",
          }}>
            <RainbowHeading size={20} tag="h3">Where to Find Us</RainbowHeading>
            <div style={{ height: 12 }} />
            <div style={{
              fontFamily: body, fontSize: 14, color: C.ink + "99", lineHeight: 1.8,
            }}>
              <strong style={{ color: C.ink }}>Lumina Dance Company</strong><br />
              Eden Business Centre, South Stour Ave<br />
              Ashford, Kent TN23 7RS<br /><br />
              <span style={{ fontSize: 13 }}>
                12 parking spaces available outside the studio (please park considerately).
                The road is permit only during the day.
                Walking distance from Ashford town centre and Ashford International train station.
              </span>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}
